module.exports = __webpack_public_path__ + "img/icn_premium.b46702a9.svg";